import React from "react";
import { useLanguage } from "./LanguageContext";
import { Button } from "@/shared/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "default", className }) {
  const { language, setLanguage } = useLanguage(); 

  const languages = [
    { code: "en", shortCode: "US", name: "English", flag: "🇺🇸" },
    { code: "th", shortCode: "TH", name: "ไทย", flag: "🇹🇭" }, 
  ];

  const selectedLang = languages.find((l) => l.code === language) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant={variant} size="icon" className={className}>
          <span className="font-semibold text-sm">{selectedLang.shortCode}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onSelect={(event) => {
              event.preventDefault();
              setLanguage(lang.code);
            }}
            className={language === lang.code ? "bg-slate-100" : ""}
          >
            <span className="mr-2 text-base">{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}